import styled from 'styled-components'

export const RangeDatePickerCaptionContainer = styled.div`
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
`
